<div class="title-wrapper">
  <span class="custom-title">{{headerTitle}}</span>
  <span class="sub-title" *ngIf="subTitle">{{subTitle}}</span>
</div>
